import React, { Component } from "react";
import PatientList from "./PatientList";
import PatientAddEdit from "./PatientAddEdit";

class Patient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <PatientList onClick={this.handleClick} />;
    } else {
      return (
        <PatientAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data, mode });
  }
}

export default Patient;
